import React from "react";
import { motion } from "framer-motion";
import { FiCornerUpLeft } from "react-icons/fi";
import useMessageGestures from "../../hooks/useMessageGestures";

const Message = ({ children, message, onReply, onShowMenu, className, style, ...otherProps }) => {
  const { elementRef, swipeOffset, swipeProgress } = useMessageGestures(
    message,
    onReply,
    onShowMenu
  );

  return (
    <div
      ref={elementRef}
      className={`msgx-message-row ${className || ""}`}
      style={{
        transform:
          swipeOffset !== 0 ? `translateX(${swipeOffset}px)` : undefined,
        transition: swipeOffset === 0 ? "transform 0.3s ease" : "none",
        ...style, // Merge external styles (for highlighting)
      }}
      {...otherProps} // Spread other props like data-message-id
    >
      {/* Swipe Reply Indicator */}
      {swipeOffset > 0 && (
        <motion.div
          className="msgx-swipe-reply-indicator"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{
            opacity: swipeProgress,
            scale: 0.8 + swipeProgress * 0.2,
          }}
        >
          <FiCornerUpLeft />
        </motion.div>
      )}

      {/* Message Content */}
      {children}
    </div>
  );
};

export default Message;
